import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@/components/auth/AuthProvider';
import { AccessProvider } from '@/components/access/AccessProvider';
import { router } from '@/router';

export function App() {
  return (
    <AuthProvider>
      <AccessProvider>
        <RouterProvider router={router} />
      </AccessProvider>
    </AuthProvider>
  );
}
